import React from 'react';
import { DropZoneBase } from './DropZoneBase';
import { DEFAULT_TEXT_ACCERT, DEFAULT_OUTPUT_FORMAT, OUTPUT_FORMATS } from '../ai/shared/constants/outputFormats';

export const TextDropZone = ({
    showFormatSelector,
    outputFormats = OUTPUT_FORMATS,
    defaultOutputFormat = DEFAULT_OUTPUT_FORMAT,
    defaultTemplate = null,   
    onFormatChange,   
    onTemplateChange,
    fileTypesDescription,
    accept = DEFAULT_TEXT_ACCERT,
    ...otherProps
}) => {
    const computedFileTypesDescription =
        fileTypesDescription ?? outputFormats.map((f) => f.label).join(', ');

    return (
        <DropZoneBase
            {...otherProps}
            className="text"
            accept={accept}
            fileTypesDescription={computedFileTypesDescription}
            dropzoneMessage="Перетащите текстовые файлы сюда или выберите их вручную"
            showFormatSelector={showFormatSelector}
            outputFormats={outputFormats}
            defaultOutputFormat={defaultOutputFormat}
            defaultTemplate={defaultTemplate}
            onFormatChange={onFormatChange}
            onTemplateChange={onTemplateChange}
            recomendedMaxFileLength={"Один документ — до 40 страниц (≈ 50к символов). Длинные тексты дробите на части — так результат будет качественнее."}
        />
    );
};